@use '../../../../../../styles/Colors.scss' as Colors;
@use '../../../../../../styles/Constants.scss' as Constants;


.value {
	padding-left: Constants.$val-spacing-s;
}
